export default "__VITE_ASSET__066e08e4__"